export const SET_CHANNEL = 'SET_CHANNEL';
export const SET_CHANNEL_HISTORY = 'SET_CHANNEL_HISTORY';
export const SEND_CHANNEL_MESSAGE = 'SEND_CHANNEL_MESSAGE';
export const FILTER_CHANNEL_MESSAGES = 'FILTER_CHANNEL_MESSAGES';
export const CLEAR_CHANNEL = 'CLEAR_CHANNEL';
export const SET_CHANNEL_PARTICIPANTS = 'SET_CHANNEL_PARTICIPANTS';
export const SET_CHANNEL_NEW_MESSAGE = 'SET_CHANNEL_NEW_MESSAGE';
export const SET_READ_NOTIFICATIONS   = 'SET_READ_NOTIFICATIONS';
